<template>
  <v-avatar color="primary">
    <img
      :key="userProfile.id"
      v-if="userProfile && userProfile.image"
      :src="userProfile.image.contentUrl"
      style="object-fit: cover;"
    />
    <v-icon size="50" v-else dark> mdi-account-circle </v-icon>
  </v-avatar>
</template>
<script>
export default {
  props: {
    userProfile: Object,
  },
};
</script>